import { useEffect } from "react";
import { analytics, posthogClient } from "@/lib/analytics";
import { imagineStore } from "@/stores/imagine.store";
import { imagineConfigStore } from "@/stores/imagine-config.store";
import { useAuth } from "./user-auth";

/**
 * Synchronizes user, project, and session context into the analytics client.
 * Intended to be called once near the top of the app (e.g., ClientProviders).
 */
export function useAnalyticsIdentity() {
  const { user } = useAuth();
  const projectId = imagineStore.use.projectId();
  const sessionId = imagineConfigStore.use.consoleSessionId();

  useEffect(() => {
    if (user?.$id) {
      analytics.identify(user.$id, { sessionId, projectId });
      posthogClient.identify(user.$id, { sessionId, projectId });
    } else {
      posthogClient.reset();
    }
  }, [user?.$id, projectId, sessionId]);
}
